
  (function() {
    // 切换单个卡片的展开/收起状态
    function toggleBox(box) {
      box.classList.toggle('open');
    }

    // 全局点击委托：监听所有 .product-coll-box-title 的点击
    document.addEventListener('click', function(e) {
      // 找到实际被点击的标题元素
      const title = e.target.closest('.product-coll-box-title');
      if (!title) return;

      // 找到所属的卡片容器
      const box = title.closest('.product-coll-box');
      if (!box) return;

      // 阻止事件冒泡（防止意外）
      e.preventDefault();

      // 切换当前卡片的展开状态
      toggleBox(box);
    });

    // 初始化：确保所有卡片默认都是收起状态（若没有 .open 类）
    // 如果你想第一个卡片默认展开，可以手动加 class="product-coll-box open"
    document.querySelectorAll('.product-coll-box').forEach(function(box) {
      // 如果没有 open 类，就确保它是收起（内容隐藏）
      if (!box.classList.contains('open')) {
        box.classList.remove('open'); // 确保类不存在
      }
    });
  })();
